import { today } from '@shared/utils'
import { CurrentOrganizationUserReadable } from '@shared-api/organization'

export const initialEmailHtml = (
  formValues: { title?: string; valid_till?: number; invoice_number?: string },
  fields: { total?: number }[],
  currency: string,
  user?: CurrentOrganizationUserReadable
): string => {
  const totalAmount = fields?.reduce(
    (acc: number, i: { total?: number }) => acc + (i?.total || 0),
    0
  )

  return `<div style="font-family: Arial, Helvetica, sans-serif; color: #333333; line-height: 1.6; max-width: 600px;">
    <div style="margin-bottom: 24px;">
        <h2 style="margin: 0 0 8px 0; color: #1a1a1a; font-size: 20px; font-weight: 600;">
            Invoice ${formValues?.invoice_number || '{{ invoice_number }}'}
        </h2>
        <p style="margin: 0; color: #666666; font-size: 14px;">
            ${formValues.title || '{{ title }}'}
        </p>
    </div>

    <p style="margin: 0 0 20px 0;">Dear Customer,</p>
    
    <p style="margin: 0 0 20px 0;">
        Thank you for your business. Please find attached the invoice for the services provided.
    </p>

    <div style="background-color: #f8f9fa; padding: 20px; border-radius: 4px; margin: 24px 0;">
        <h3 style="margin: 0 0 16px 0; color: #1a1a1a; font-size: 16px; font-weight: 600;">
            Invoice Details
        </h3>
        <table style="width: 100%; border-collapse: collapse;">
            <tr>
                <td style="padding: 8px 0; color: #666666; font-size: 14px;">Invoice Number:</td>
                <td style="padding: 8px 0; font-weight: 600; text-align: right; font-size: 14px;">
                    ${formValues?.invoice_number || '{{ invoice_number }}'}
                </td>
            </tr>
            <tr>
                <td style="padding: 8px 0; color: #666666; font-size: 14px;">Invoice Date:</td>
                <td style="padding: 8px 0; font-weight: 600; text-align: right; font-size: 14px;">
                    ${today.format('MMM. D, YYYY')}
                </td>
            </tr>
            <tr>
                <td style="padding: 8px 0; color: #666666; font-size: 14px;">Due Date:</td>
                <td style="padding: 8px 0; font-weight: 600; text-align: right; font-size: 14px;">
                    ${
                      formValues.valid_till
                        ? today
                            .add(formValues.valid_till, 'days')
                            .format('MMM. D, YYYY')
                        : '{{ due_date }}'
                    }
                </td>
            </tr>
            <tr style="border-top: 2px solid #dee2e6;">
                <td style="padding: 12px 0 0 0; color: #1a1a1a; font-size: 16px; font-weight: 600;">
                    Total Amount:
                </td>
                <td style="padding: 12px 0 0 0; font-weight: 700; text-align: right; font-size: 18px; color: #1a73e8;">
                    ${
                      totalAmount
                        ? `${totalAmount} ${currency || ''}`
                        : '{{ total_amount }}'
                    }
                </td>
            </tr>
        </table>
    </div>

    <p style="margin: 24px 0 12px 0; font-size: 14px;">
        If you have any questions regarding this invoice or require any clarification, please don't hesitate to contact us.
    </p>

    <p style="margin: 24px 0 8px 0; font-size: 14px;">
        Thank you for your prompt attention to this matter.
    </p>

    <div style="margin-top: 32px; padding-top: 20px; border-top: 1px solid #e0e0e0;">
        <p style="margin: 0 0 4px 0; font-size: 14px; font-weight: 600;">Best Regards,</p>
        <p style="margin: 0; font-size: 14px; color: #666666;">${
          user?.organization?.name || '{{ company_name }}'
        }</p>
    </div>
</div>`
}
